<template>
  <div>
    <button @click="requeuePendingTasks">Requeue All Tasks</button>
    <button
      :disabled="!taskType"
      @click="requeuePendingTasksByTaskType(taskType)"
    >
      Requeue Task Type
    </button>
    <input v-model="taskType" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TaskQueueAction',
  data() {
    return {
      taskType: null
    }
  },
  methods: mapActions(['requeuePendingTasks', 'requeuePendingTasksByTaskType'])
}
</script>
